import { CertificateOutlineIcon } from './CertificateOutlineIcon';

/**
 * author: Michael Richins
 * id 6F755EB5-B2E1-413A-A919-3F0DCE69E48A
 * name certificate-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/certificate-outline.svg
 * tags
 */
export const SealOutlineIcon = CertificateOutlineIcon;
export default SealOutlineIcon